import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { CryptodraftContext } from '../../../../contexts/card/cryptodraft/context';
import { showAlert } from '../../../../utilities/notifications';
import { PGW_BUY_CRYPTO } from '../../mutations';
import { cryptodraftScreens, forceUpdateOptions } from '../constants';
import MainBodyLayout from '../partials/MainBodyLayout';
import { GenericLoading } from '../../../../components/Placeholders';
import PgwIframe from '../../../../components/PgwIframe';

const PaymentCard = () => {
  const { t: translate } = useTranslation();

  const { state, openScreen, forceUpdateAction } = useContext(CryptodraftContext);

  const [pgwUrl, setPgwUrl] = useState();
  const [showPgwFooter, setShowPgwFooter] = useState(false);

  const { mutate: buyCryptoPGW, isLoading } = useMutation(PGW_BUY_CRYPTO, {
    onSettled: (data, error) => {
      if (error || (data && !data?.redirectUrl)) {
        showAlert({ message: error?.message || data, type: 'danger' });
      } else if (data && data.redirectUrl) {
        setPgwUrl(data.redirectUrl);
      }
    },
  });

  useEffect(() => {
    buyCryptoPGW(state?.pgwRequestParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.pgwRequestParams]);

  const handleResolvePgw = (isConfirmed) => {
    if (!isConfirmed) {
      setShowPgwFooter(false);
    } else {
      setShowPgwFooter(true);
    }
  };

  const continueBtnHandler = () => {
    forceUpdateAction(forceUpdateOptions.WALLETS, true);
    openScreen(cryptodraftScreens.CALCULATOR);
  };

  return (
    <MainBodyLayout
      withBack
      withInfoIcon
      onPrevClick={() => openScreen(cryptodraftScreens.ADD_MORE_COLLATERAL)}
      title={translate('add_payment_card_title')}>
      {isLoading ? (
        <GenericLoading />
      ) : (
        <>
          <PgwIframe pgwUrl={pgwUrl} onPgwResolve={handleResolvePgw} style={{ height: '32rem' }} />
        </>
      )}
      {pgwUrl && showPgwFooter && (
        <div className="btn-container">
          <button type="button" className="btn py-3 btn-primary w-100" onClick={continueBtnHandler}>
            {translate('continue_btn_title')}
          </button>
        </div>
      )}
    </MainBodyLayout>
  );
};

export default PaymentCard;
